import type React from "react";
import type InputProps from "./Input.model";
import { StyledInput, StyledInputPostFix, StyledInputWrapper } from "./Input.styled";

export const Input: React.FC<InputProps> = ({ dataCy, pasteDisabled, postfixLabel, ...props }) => (
  <StyledInputWrapper $hasError={props.hasError} $hasPostFix={!!postfixLabel}>
    <StyledInput
      $hasError={props.hasError}
      $hasPostFix={!!postfixLabel}
      data-cy={dataCy}
      {...props}
      /* Optionally disable paste event in field */
      {...(pasteDisabled
        ? {
            onPaste: (e) => e.preventDefault(),
          }
        : {})}
    />
    {postfixLabel && (
      <StyledInputPostFix $hasError={props.hasError}>
        <span>{postfixLabel}</span>
      </StyledInputPostFix>
    )}
  </StyledInputWrapper>
);

export default Input;
